import { ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PRIMARY, Reveal } from "@/components/landing/shared";

export const GuaranteeBand = ({ startTeam }) => (
  <section className="py-6">
    <div className="mx-auto max-w-6xl px-4 sm:px-6">
      <Reveal>
        <div data-testid="landing-guarantee-band" className="flex flex-col items-center gap-4 rounded-2xl border border-[color:rgba(124,247,230,0.22)] bg-[color:var(--rb-obsidian)] p-7 text-center sm:flex-row sm:text-left">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[color:rgba(45,212,191,0.12)]"><ShieldCheck className="h-6 w-6 text-[color:var(--rb-accent)]" /></div>
          <div className="flex-1">
            <h3 className="rb-display text-lg font-semibold text-[color:var(--rb-text)]">No unscanned path to your team's machines</h3>
            <p className="mt-1 text-sm text-[color:var(--rb-text-dim)]">Every artifact is safety-scanned before an admin can approve it, and nothing reaches the plugin registry without that approval. Free for up to 5 seats — no credit card.</p>
          </div>
          <Button onClick={startTeam} className={`rounded-xl ${PRIMARY}`} data-testid="landing-guarantee-cta">Start a team registry</Button>
        </div>
      </Reveal>
    </div>
  </section>
);
